//@ts-check
import * as THREE from "three";
import { Box3, LineBasicMaterial, Vector3 } from "three";
import { ModelManager } from "../manager/ModelManager";
import { DBEntity } from "./DBEntity";
import { MLayer } from "./MLayer";
import { Context } from "./context";
import { FMathUtils } from "@/utils/FMathUtils";
/**
 * 范围选择工具
 */
let testMesh = new THREE.LineSegments();

export class SelectionBox {
  private m_frustum = new THREE.Frustum();
  private m_center = new THREE.Vector3();

  private m_tmpPoint = new THREE.Vector3();

  private m_vecNear = new THREE.Vector3();
  private m_vecTopLeft = new THREE.Vector3();
  private m_vecTopRight = new THREE.Vector3();
  private m_vecDownRight = new THREE.Vector3();
  private m_vecDownLeft = new THREE.Vector3();

  private m_vecFarTopLeft = new THREE.Vector3();
  private m_vecFarTopRight = new THREE.Vector3();
  private m_vecFarDownRight = new THREE.Vector3();
  private m_vecFarDownLeft = new THREE.Vector3();

  private m_vectemp1 = new THREE.Vector3();
  private m_vectemp2 = new THREE.Vector3();
  private m_vectemp3 = new THREE.Vector3();

  private selectType: string = "include";
  private m_context: Context;
  m_camera: THREE.Camera;
  m_model: ModelManager;
  m_startPoint: THREE.Vector3;
  m_collection: (DBEntity | THREE.Object3D)[] = [];
  m_endPoint: THREE.Vector3;
  m_threeModel: MLayer;
  instances: any;
  m_deep: number;
  m_auxModel: MLayer;
  frontSelectBox!: THREE.Sprite;
  reverseSelectBox!: THREE.Sprite;
  public BoxStartPoint: THREE.Vector3 = new THREE.Vector3();
  public BoxEndPoint: THREE.Vector3 = new THREE.Vector3();

  /**
   *
   * @param camra 相交查询
   * @param model
   * @param threeModel
   */
  constructor(
    camra: THREE.Camera,
    model: ModelManager,
    threeModel: MLayer,
    aux: MLayer
  ) {
    this.m_camera = camra;
    this.m_model = model;
    this.m_startPoint = new Vector3();
    this.m_endPoint = new Vector3();
    this.m_threeModel = threeModel;
    this.m_auxModel = aux;
    this.m_deep = Number.MAX_VALUE;
    this.m_context = model.m_context;
  }

  public get WorldStartPoint() {
    return new THREE.Vector3().copy(this.m_startPoint).unproject(this.m_camera);
  }
  public get WorldEndPoint() {
    return new THREE.Vector3().copy(this.m_endPoint).unproject(this.m_camera);
  }

  public set SelectType(type: string) {
    this.selectType = type;
  }

  public select(
    startPoint: THREE.Vector3 | undefined = undefined,
    endPoint: THREE.Vector3 | undefined = undefined
  ) {
    this.m_startPoint = startPoint || this.m_startPoint;
    this.m_endPoint = endPoint || this.m_endPoint;
    this.updateFrustum(this.m_startPoint, this.m_endPoint);
    // this.searchChildInFrustum(this.m_frustum, this.m_threeModel);
    // this.searchChildInFrustum(this.m_frustum, this.m_auxModel);
    // this.searchChildInFrustum(this.m_frustum, this.m_model);
    this.searchChildInFrustum();
  }

  updateFrustum(startPoint: THREE.Vector3, endPoint: THREE.Vector3) {
    if (startPoint.x === endPoint.x) {
      endPoint.x += Number.EPSILON;
    }

    if (startPoint.y === endPoint.y) {
      endPoint.y += Number.EPSILON;
    }

    if (this.m_camera instanceof THREE.PerspectiveCamera) {
      this.m_camera.updateProjectionMatrix();
      this.m_camera.updateMatrixWorld();
      this.m_tmpPoint.copy(startPoint);
      this.m_tmpPoint.x = Math.min(startPoint.x, endPoint.x);
      this.m_tmpPoint.y = Math.max(startPoint.y, endPoint.y);
      endPoint.x = Math.max(startPoint.x, endPoint.x);
      endPoint.y = Math.min(startPoint.y, endPoint.y);
      this.m_vecNear.setFromMatrixPosition(this.m_camera.matrixWorld);
      this.m_vecTopLeft.set(this.m_tmpPoint.x, this.m_tmpPoint.y, 0.5);
      this.m_vecTopRight.set(endPoint.x, this.m_tmpPoint.y, 0);
      this.m_vecDownRight.set(endPoint.x, endPoint.y, 0.5);
      this.m_vecDownLeft.set(this.m_tmpPoint.x, endPoint.y, 0);

      this.m_vecTopLeft.unproject(this.m_camera);
      this.m_vecTopRight.unproject(this.m_camera);
      this.m_vecDownRight.unproject(this.m_camera);
      this.m_vecDownLeft.unproject(this.m_camera);

      this.m_vectemp1.copy(this.m_vecTopLeft).sub(this.m_vecNear);
      this.m_vectemp2.copy(this.m_vecTopRight).sub(this.m_vecNear);
      this.m_vectemp3.copy(this.m_vecDownRight).sub(this.m_vecNear);
      this.m_vectemp1.normalize();
      this.m_vectemp2.normalize();
      this.m_vectemp3.normalize();

      this.m_vectemp1.multiplyScalar(this.m_deep);
      this.m_vectemp2.multiplyScalar(this.m_deep);
      this.m_vectemp3.multiplyScalar(this.m_deep);
      this.m_vectemp1.add(this.m_vecNear);
      this.m_vectemp2.add(this.m_vecNear);
      this.m_vectemp3.add(this.m_vecNear);

      const planes = this.m_frustum.planes;
      planes[0].setFromCoplanarPoints(
        this.m_vecNear,
        this.m_vecTopLeft,
        this.m_vecTopRight
      );
      planes[1].setFromCoplanarPoints(
        this.m_vecNear,
        this.m_vecTopRight,
        this.m_vecDownRight
      );
      planes[2].setFromCoplanarPoints(
        this.m_vecDownRight,
        this.m_vecDownLeft,
        this.m_vecNear
      );
      planes[3].setFromCoplanarPoints(
        this.m_vecDownLeft,
        this.m_vecTopLeft,
        this.m_vecNear
      );
      planes[4].setFromCoplanarPoints(
        this.m_vecTopRight,
        this.m_vecDownRight,
        this.m_vecDownLeft
      );
      planes[5].setFromCoplanarPoints(
        this.m_vectemp3,
        this.m_vectemp2,
        this.m_vectemp1
      );
      planes[5].normal.multiplyScalar(-1);
    } else if (this.m_camera instanceof THREE.OrthographicCamera) {
      this.m_camera.updateProjectionMatrix();
      this.m_camera.updateMatrixWorld();
      const left = Math.min(startPoint.x, endPoint.x);
      const top = Math.max(startPoint.y, endPoint.y);
      const right = Math.max(startPoint.x, endPoint.x);
      const down = Math.min(startPoint.y, endPoint.y);

      this.m_vecTopLeft.set(left, top, -1);
      this.m_vecTopRight.set(right, top, -1);
      this.m_vecDownRight.set(right, down, -1);
      this.m_vecDownLeft.set(left, down, -1);

      this.m_vecFarTopLeft.set(left, top, 1);
      this.m_vecFarTopRight.set(right, top, 1);
      this.m_vecFarDownRight.set(right, down, 1);
      this.m_vecFarDownLeft.set(left, down, 1);

      this.m_vecTopLeft.unproject(this.m_camera);
      this.m_vecTopRight.unproject(this.m_camera);
      this.m_vecDownRight.unproject(this.m_camera);
      this.m_vecDownLeft.unproject(this.m_camera);

      this.m_vecFarTopLeft.unproject(this.m_camera);
      this.m_vecFarTopRight.unproject(this.m_camera);
      this.m_vecFarDownRight.unproject(this.m_camera);
      this.m_vecFarDownLeft.unproject(this.m_camera);

      const planes = this.m_frustum.planes;

      planes[0].setFromCoplanarPoints(
        this.m_vecTopLeft,
        this.m_vecFarTopLeft,
        this.m_vecFarTopRight
      );
      planes[1].setFromCoplanarPoints(
        this.m_vecTopRight,
        this.m_vecFarTopRight,
        this.m_vecFarDownRight
      );
      planes[2].setFromCoplanarPoints(
        this.m_vecFarDownRight,
        this.m_vecFarDownLeft,
        this.m_vecDownLeft
      );
      planes[3].setFromCoplanarPoints(
        this.m_vecFarDownLeft,
        this.m_vecFarTopLeft,
        this.m_vecTopLeft
      );
      planes[4].setFromCoplanarPoints(
        this.m_vecTopRight,
        this.m_vecDownRight,
        this.m_vecDownLeft
      );
      planes[5].setFromCoplanarPoints(
        this.m_vecFarDownRight,
        this.m_vecFarTopRight,
        this.m_vecFarTopLeft
      );
      planes[5].normal.multiplyScalar(-1);
    } else {
      console.error("THREE.SelectionBox: Unsupported camera type.");
    }
  }
  searchChildInFrustum() {
    let { Lines, Meshs } = this.m_model;
    for (let key in Lines) {
      let items = Lines[key];
      let layer_id = key.split("_")[0];
      if (
        this.m_model.LayerTable[layer_id].Visible &&
        (this.m_model.LayerTable[layer_id].Enabled ||
          this.m_model.isForceCapture)
      ) {
        let { lines } = items;
        for (let i = 0; i < lines.length; i++) {
          let line = lines[i];
          if (line.sphere) {
            let center = new THREE.Vector3().set(
              line.sphere.center.x,
              line.sphere.center.y,
              line.sphere.center.z
            );
            let sphere = new THREE.Sphere(center, line.sphere.radius);
            if (!this.m_frustum.intersectsSphere(sphere)) continue;
          }
          for (let i = 0; i < line.points.length - 3; i += 3) {
            let start = new THREE.Vector3().set(
              line.points[i + 0],
              line.points[i + 1],
              line.points[i + 2]
            );
            let end = new THREE.Vector3().set(
              line.points[i + 3],
              line.points[i + 4],
              line.points[i + 5]
            );
            if (
              FMathUtils.RectFilterLineSegement(
                this.BoxStartPoint,
                this.BoxEndPoint,
                [start, end]
              )
            ) {
              if (!this.m_collection.includes(line)) {
                this.m_collection.push(line);
              }
              break;
            }
          }
        }
      }
    }
    for (let key in Meshs) {
      let items = Meshs[key];
      let layer_id = key.split("_")[0];
      if (
        this.m_model.LayerTable[layer_id].Visible &&
        (this.m_model.LayerTable[layer_id].Enabled ||
          this.m_model.isForceCapture)
      ) {
        let { meshs } = items;
        for (let i = 0; i < meshs.length; i++) {
          let mesh = meshs[i];
          if (mesh.sphere) {
            let center = new THREE.Vector3().set(
              mesh.sphere.center.x,
              mesh.sphere.center.y,
              mesh.sphere.center.z
            );
            let sphere = new THREE.Sphere(center, mesh.sphere.radius);
            if (!this.m_frustum.intersectsSphere(sphere)) continue;
          }
          for (let i = 0; i < mesh.vertexs.length - 3; i += 3) {
            let start = new THREE.Vector3().set(
              mesh.vertexs[i + 0],
              mesh.vertexs[i + 1],
              mesh.vertexs[i + 2]
            );
            let end = new THREE.Vector3().set(
              mesh.vertexs[i + 3],
              mesh.vertexs[i + 4],
              mesh.vertexs[i + 5]
            );
            if (
              FMathUtils.RectFilterLineSegement(
                this.BoxStartPoint,
                this.BoxEndPoint,
                [start, end]
              )
            ) {
              if (!this.m_collection.includes(mesh)) {
                this.m_collection.push(mesh);
              }
              break;
            }
          }
        }
      }
    }
    let { ThreeLayer } = this.m_context.SceneManager;
    let { PolygonDatas, PMesh } = this.m_context.ViewManager;
    if (!ThreeLayer.userData.disEnable && PMesh.visible) {
      for (const value of PolygonDatas.values()) {
        let geometry = value.shapeMesh.geometry.clone();
        let sphere = geometry.boundingSphere;
        if (sphere && !this.m_frustum.intersectsSphere(sphere)) continue;
        let points = Array.from(geometry.attributes.position.array);
        for (let i = 0; i < points.length - 3; i += 3) {
          let start = new THREE.Vector3().set(
            points[i + 0],
            points[i + 1],
            points[i + 2]
          );
          let end = new THREE.Vector3().set(
            points[i + 3],
            points[i + 4],
            points[i + 5]
          );
          if (
            FMathUtils.RectFilterLineSegement(
              this.BoxStartPoint,
              this.BoxEndPoint,
              [start, end]
            )
          ) {
            this.m_collection.push(value.shapeMesh.clone());
            break;
          }
        }
      }
    }
  }
  // 创建正反框选标志(){
  // createFrontAndReverseSign() {
  //   const map1 = new THREE.TextureLoader().load("./icon/frontSelectBox.svg");
  //   const material1 = new THREE.SpriteMaterial({ map: map1 });
  //   const sprite1 = new THREE.Sprite(material1);
  //   sprite1.name = "frontSelectBox";
  //   this.frontSelectBox = sprite1;
  //   sprite1.visible = false;
  //   this.m_threeModel.add(sprite1);

  //   const map2 = new THREE.TextureLoader().load("./icon/reverseSelectBox.svg");
  //   const material2 = new THREE.SpriteMaterial({ map: map2 });
  //   const sprite2 = new THREE.Sprite(material2);
  //   sprite2.name = "reverseSelectBox";

  //   this.reverseSelectBox = sprite2;
  //   sprite2.visible = false;
  //   this.m_threeModel.add(sprite2);
  // }

  // clearFrontAndReverseSign() {
  //   this.m_threeModel.remove(this.frontSelectBox);
  //   this.m_threeModel.remove(this.reverseSelectBox);
  // }
  public get Collection() {
    return this.m_collection;
  }
  public Box() {
    let box3=new THREE.Box3()
    box3.expandByPoint(this.BoxStartPoint)
    box3.expandByPoint(this.BoxEndPoint)
    return box3
  }
}
